import React from 'react';
import CheckBox from 'shared/components/check-box/CheckBox';
import { QuestionnaireOptionsArr } from 'utils/constants/Questionnaire.js';

class QuestionnaireOptions extends React.Component {
  render() {
    let { resources } = this.props;
    return (
      <div className="questionnaire-options">
        <div className="options-hint">In order to help you achieve your goal within your time frame, what resources/support do you feel are most valuable? Select all that apply. </div>
        {
          QuestionnaireOptionsArr.map(option => {
            return(
              <CheckBox text={option} checked={resources.includes(option)} disabled />
            );
          })
        }
      </div>
    );
  }
}

export default QuestionnaireOptions;